<template>
  <div>
    <div v-if="url" style="height: calc(100vh - 50px); overflow-y: scroll; -webkit-overflow-scrolling: touch">
      <iframe style="height: calc(100% - 1.5rem); width: 100%" ref="iframe" scrolling="auto" frameborder="0" id="iframe"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'kefu',
  data() {
    return {
      url: null,
    };
  },
  created() {
    this.getservicerurl();
  },
  methods: {
    getUserInfo() {
      const fromStore = (this.$store && this.$store.state && this.$store.state.userInfo) || {};
      let fromLocal = {};
      try {
        fromLocal = JSON.parse(localStorage.getItem('userInfo') || '{}') || {};
      } catch (e) {
        fromLocal = {};
      }
      return Object.assign({}, fromLocal, fromStore);
    },
    fillKefuUrl(rawUrl) {
      const user = this.getUserInfo();
      const visitorId = String(
        user.id || user.userid || user.user_id || user.uid || ''
      );
      const visitorName = String(
        user.username || user.account || user.name || user.nickname || user.user_name || visitorId || 'guest'
      );
      let url = String(rawUrl || '').trim();
      if (!url) {
        return '';
      }

      const replacements = {
        '{visiter_id}': visitorId,
        '{visiter_name}': encodeURIComponent(visitorName),
        '{visitor_id}': visitorId,
        '{visitor_name}': encodeURIComponent(visitorName),
        '%7Bvisiter_id%7D': visitorId,
        '%7Bvisiter_name%7D': encodeURIComponent(visitorName),
        '%7Bvisitor_id%7D': visitorId,
        '%7Bvisitor_name%7D': encodeURIComponent(visitorName)
      };

      Object.keys(replacements).forEach(key => {
        url = url.split(key).join(replacements[key]);
      });

      // 后台若只配了空参数，也补上当前用户
      try {
        const parsed = new URL(url, window.location.origin);
        if (!parsed.searchParams.get('visiter_id')) {
          parsed.searchParams.set('visiter_id', visitorId);
        }
        if (!parsed.searchParams.get('visiter_name')) {
          parsed.searchParams.set('visiter_name', visitorName);
        }
        url = parsed.toString();
      } catch (e) {
        // ignore invalid absolute url parsing
      }

      return url;
    },
    getservicerurl() {
      const that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          if (that.$parent && that.$parent.showTost) {
            that.$parent.showTost(0, res.message);
          }
          return;
        }
        that.url = that.fillKefuUrl(res.data && res.data.url);
      });
    },
  },
  updated() {
    if (this.$refs.iframe && this.url) {
      this.$refs.iframe.contentWindow.location.replace(this.url);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mode/kefu.vue